import React, { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { Box, Typography, Grid, Paper} from "@mui/material";
import { useError } from "../../../contexts/ErrorContext";
import useApi from "../../../hooks/useGaneshApi";


interface OmniData {
    percentage_7_days_or_less: string;
    percentage_7_to_30_days: string;
    percentage_more_than_30_days: string;
    }

const OmniPercentageCards: React.FC = () => {
  const { showError } = useError();
  const { apiRequest } = useApi();

  const fetchOmniPercentageData = async () => {
    const url = `/brand_reports/insights/percentage_7_30`;
    const response = await apiRequest<any[]>(url, {
      method: "GET",
    });
    return response.data;
  };

  const { data, error, isLoading } = useQuery({
    queryKey: ["omniPercentageData"],
    queryFn: fetchOmniPercentageData,
    staleTime: 120000,
    refetchInterval: false,
  });

  useEffect(() => {
    if (error) {
      showError(error?.message || `Failed to get Omni percentage distribution data`);
    }
  }, [error, showError]);

  if (isLoading) {
    return <Typography>Loading...</Typography>;
  }

  if (!data) {
    return <Typography>No data available</Typography>;
  }

  const omniData = data[0];

  return (
    <Box sx={{ marginTop: "25px" }}>
      <Typography variant="h5" sx={{ marginBottom: "15px" }}>
      Omni Observation Recency Breakdown
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <Paper elevation={2} style={{ padding: "16px" }}>
            <Typography variant="subtitle2" style={{ color: "black", marginBottom: "8px" }}>
              Recent Omnis
            </Typography>
            <Typography variant="body2" style={{ color: "gray", marginBottom: "8px" }}>
              Observation in the Last 7 Days
            </Typography>
            <Typography variant="h6" style={{ fontWeight: "bold" }}>
              {`${omniData.percentage_7_days_or_less}%`}
            </Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Paper elevation={2} style={{ padding: "16px" }}>
            <Typography variant="subtitle2" style={{ color: "black", marginBottom: "8px" }}>
              Moderate Age Omnis
            </Typography>
            <Typography variant="body2" style={{ color: "gray", marginBottom: "8px" }}>
              Observation from 8 to 30 Days Ago
            </Typography>
            <Typography variant="h6" style={{ fontWeight: "bold" }}>
              {`${omniData.percentage_7_to_30_days}%`}
            </Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Paper elevation={2} style={{ padding: "16px" }}>
            <Typography variant="subtitle2" style={{ color: "black", marginBottom: "8px" }}>
              Older Omnis
            </Typography>
            <Typography variant="body2" style={{ color: "gray", marginBottom: "8px" }}>
              Observation More Than 30 Days Ago
            </Typography>
            <Typography variant="h6" style={{ fontWeight: "bold" }}>
              {`${omniData.percentage_more_than_30_days}%`}
            </Typography>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default OmniPercentageCards;
